export enum EFeatureFlagType {
  HELLO_WORLD = 'HELLO_WORLD',
}

interface IFeatureFlag {
  name: string;
  type: EFeatureFlagType;
  enabled: boolean;
  description: string;
}

export interface IFeatureFlagStore {
  featureFlags: IFeatureFlag[];
}

export interface IFeatureFlagStoreActions {
  toggleFeatureFlag: (data: { name: string }) => void;
}
